import(/* webpackMode: "eager" */ "/vercel/path0/src/app/leaderboard/page.tsx");
